import { env } from 'src/config/env';
import { posthogEventMap, type EventMapping } from './posthogEventMap';
import { toSnakeCase } from './posthogTaxonomy';

export interface PosthogPayload {
  event: string;
  properties: Record<string, unknown>;
}

export function toPosthogEvent(
  legacyName: string,
  params: Record<string, unknown> = {},
  map: Partial<Record<string, EventMapping>> = posthogEventMap,
): PosthogPayload {
  const mapping = map[legacyName];
  const event = mapping?.event ?? toSnakeCase(legacyName);
  const propMap = mapping?.properties ?? {};
  const properties: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(params)) {
    const pm = propMap[key];
    if (pm === undefined) {
      if (env.isDev) {

        console.warn(`[analytics] unmapped property "${key}" on event "${legacyName}"`);
      }
      properties[toSnakeCase(key)] = value;
    } else {
      const mapped = pm.values?.[String(value)];
      properties[pm.to] = mapped !== undefined ? mapped : value;
    }
  }

  if (mapping?.inject) {
    for (const [key, spec] of Object.entries(mapping.inject)) {
      properties[key] = spec.value;
    }
  }

  return { event, properties };
}
